import { NotificationHelper } from "@/components/Notification";
import { useAppStore } from "@/store/appStore";
import { useMatchRoute } from "@tanstack/react-router";
import { useCommonTranslation } from "@/services/culture/common.translations";

interface RootLayoutProps {
  top: React.ReactNode;
  nav: React.ReactNode;
  main: React.ReactNode;
  mainTestId?: string;
  moduleTestId?: string;
}

const RootLayout = ({ top, nav, main, mainTestId, moduleTestId }: RootLayoutProps) => {
  const currentCompany = useAppStore((state) => state.currentCompany);
  const isMatch = useMatchRoute();
  const isCaptureRoute = isMatch({ to: "/capture" });
  const { t } = useCommonTranslation();

  return (
    <>
      <NotificationHelper />
      <div className="flex flex-col md:grid h-full grid-cols-[auto_1fr] md:grid-cols-[auto_1fr_auto] grid-rows-[44px_1fr] [grid-template-areas:'nav_top_top'_'nav_main_aside']">
        <a href={`#${mainTestId}`} className="sr-only">
          {t("topbar.skipToMain", "Skip to main content")}
        </a>
        <header className="[grid-area:top] w-full md:w-auto order-1">{top}</header>
        <nav className="[grid-area:nav] order-3 md:order-2">{nav}</nav>
        <main
          key={isCaptureRoute ? "capture" : currentCompany}
          className="[grid-area:main] relative overflow-auto min-h-0 md:h-full flex-1 order-2 md:order-3"
          data-testid={mainTestId}
          data-module-testid={moduleTestId}
          id={mainTestId}
        >
          {main}
        </main>
      </div>
    </>
  );
};

export default RootLayout;
